import { MediaLevel, MediaLevel as PrismaClientMediaLevel } from '.prisma/client';

export const MediaLevels: {
	key: string;
	value: string;
}[] = Object.entries(PrismaClientMediaLevel)
	.map(([key, value]) => ({
		key,
		value,
	}));

export type MediaLevels = typeof MediaLevels;
